import * as React from 'react'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion'
import MuiAccordionSummary, {
  AccordionSummaryProps
} from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import TanStackTable from '@/@core/components/tanstack-tables'
import _ from 'lodash'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import CnvHG19QcPlot from '../children/quality-control-children/CnvQcPlot'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}

const SampleGeneTable = React.forwardRef(
  (
    props: {
      defaultColumns: any[]
      filterGeneData: any[]
      tableRef: any
      analysisInfo: any
      current: any
    },
    ref
  ) => {
    const { t } = useTranslation()
    const [value, setValue] = React.useState(0)

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue)
    }

    return (
      <Box width={1300}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Information" {...a11yProps(0)} />

            <Tab label="Copy number" {...a11yProps(1)} />
          </Tabs>
        </Box>

        <CustomTabPanel value={value} index={0}>
          <TanStackTable
            columns={_.cloneDeep(props.defaultColumns)
              .filter(
                (item) =>
                  !(
                    item.id === 'index' ||
                    item.id === 'articles' ||
                    item.id === 'grading'
                  )
              )
              .map((item) => {
                item.enableSorting = false

                return item
              })}
            data={props.filterGeneData}
            pagination={{
              pageIndex: 1,
              pageSize: 100
            }}
            pageCount={props.filterGeneData.length}
            setRowSelection={(rowSelection: number[]) => {
              //
            }}
            setPagination={() => {
              //
            }}
            setSortQuery={() => {
              //
            }}
            sorting={[]}
            isFetching={false}
            setPage={null}
            variantCount={0}
            totalCount={0}
            ref={props.tableRef}
            disabledExpand={true}
            analysisInfo={props.analysisInfo}
          />
        </CustomTabPanel>

        <CustomTabPanel value={value} index={1}>
          <CnvHG19QcPlot
            cnvRow={props.current?.CNV}
            row={props.current}
            onlyChrom={true}
            analysisInfo={props.analysisInfo}
          />
        </CustomTabPanel>
      </Box>
    )
  }
)

export default SampleGeneTable
